import { ppgConditionHueLabel } from "../../../constants/enum-to-text";
import { DoubleGroupedPlotModel } from "../../../models/plotting";

export class AFibPlotModel extends DoubleGroupedPlotModel {
  constructor(dataModel: any, plotTypeOptions: string[], chartId: string) {
    super(dataModel, plotTypeOptions, chartId);
    this.valueKey = "measurement_value";
    this.filterKey = "measurement_type";
    this.dateTimeKey = "measurement_datetime";
    this.hueKey = {
      "AF probability": "ppgConditions",
    };
    this.styleKey = {
      "AF probability": "tags",
    };

    this.colorMapping = {
      "Condition 1": "rgba(187, 22, 163, 1)",
      "Condition 2": "rgba(5, 195, 222, 1)",
      "Condition 3": "rgba(37, 40, 42, 1)",
    };
    this.styleMapping = {
      "ir,LGBM": "circle",
      "ir,LogReg": "triangle",
    };

    // Keyed on the raw condition, like `colorMapping` above — the legend text
    // is localized by `hueLabel`, the lookup keys deliberately are not.
    this.defaultHidden = ["Condition 1 - ir,LogReg", "Condition 2 - ir,LogReg"];
  }

  override hueLabel(hue: string) {
    return ppgConditionHueLabel(hue);
  }
}
